export const initPropHookSymbol: unique symbol = Symbol.for("Serenity.initPropHook");

declare module "../types" {
    interface PropHook<TNode extends Element = Element> {
        [initPropHookSymbol](node: TNode, propName: string): void;
    }
}
